import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(fetchSocketConnectSagaWorker),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(fetchSocketConnectSagaWatcher),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(sendSocketEventSagaWorker),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(sendSocketEventSagaWatcher),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(fetchSocketDisconnectSagaWorker),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(fetchSocketDisconnectSagaWatcher),
    _marked7 = /*#__PURE__*/_regeneratorRuntime.mark(socketSaga);

import { eventChannel } from 'redux-saga';
import { all, apply, call, fork, put, take, takeEvery } from 'redux-saga/effects';
import { history } from '@history';
import { ConstantsUtil } from '@utils';
import { Routes, SocketEvent } from '@enums';
import { FETCH_SEND_SOCKET_EVENT_REQUEST, FETCH_SOCKET_CONNECT_REQUEST, FETCH_SOCKET_DISCONNECT_REQUEST } from './socket.action-types';
import { actions } from './socket.actions';

var Connection = /*#__PURE__*/function () {
  function Connection(url) {
    _classCallCheck(this, Connection);

    _defineProperty(this, "connected", false);

    this.connected = false;
    this.url = url;
    this.connection = null;
  }

  _createClass(Connection, [{
    key: "getConnected",
    value: function getConnected() {
      return this.connected;
    }
  }, {
    key: "getInstance",
    value: function getInstance() {
      return this.connection;
    }
  }, {
    key: "start",
    value: function start() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        if (_this.url) {
          _this.connection = new WebSocket(_this.url);

          if (_this.connection) {
            _this.connection.onopen = function (event) {
              _this.connected = true;
              resolve(event);
            };

            _this.connection.onerror = function (event) {
              _this.connected = false;
              _this.connection = null;
              reject(event);
            };

            _this.connection.onclose = function (event) {
              _this.connected = false;
              _this.connection = null;
              reject(event);
            };
          } else {
            _this.connected = false;
            _this.connection = null;
            reject(new Error());
          }
        } else {
          _this.connected = false;
          _this.connection = null;
          reject(new Error());
        }
      });
    }
  }, {
    key: "invoke",
    value: function invoke(messageType, message) {
      if (this.connected && this.connection && this.connection.readyState === 1) {
        this.connection.send(message);
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this2 = this;

      return new Promise(function (resolve) {
        if (_this2.connection) {
          _this2.connection.close();

          _this2.connection.onerror = function (event) {
            _this2.connected = false;
            _this2.connection = null;
            resolve();
          };

          _this2.connection.onclose = function (event) {
            _this2.connected = false;
            _this2.connection = null;
            resolve(event);
          };

          setTimeout(function () {
            resolve();
          }, 1000);
        } else {
          _this2.connected = false;
          _this2.connection = null;
          resolve();
        }
      });
    }
  }]);

  return Connection;
}();

var connection = null;

function fetchSocketConnectSagaWorker(action) {
  var url, getEventChannel, channel, event;
  return _regeneratorRuntime.wrap(function fetchSocketConnectSagaWorker$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          url = action.payload.url;

          if (!url) {
            _context.next = 36;
            break;
          }

          if (!connection) {
            _context.next = 7;
            break;
          }

          _context.next = 6;
          return call([connection, connection.stop]);

        case 6:
          connection = null;

        case 7:
          connection = new Connection(url);
          _context.next = 10;
          return call([connection, connection.start]);

        case 10:
          _context.next = 12;
          return put(actions.fetchSocketConnectSuccess({}));

        case 12:
          _context.next = 14;
          return put({
            type: "".concat(FETCH_SOCKET_CONNECT_REQUEST, "/").concat(ConstantsUtil.actions.ASYNC_SUCCESS)
          });

        case 14:
          getEventChannel = function getEventChannel(connection) {
            return eventChannel(function (emit) {
              var handler = function handler(data) {
                var parsedData;

                if (typeof data === 'string') {
                  parsedData = data;
                } else {
                  parsedData = JSON.parse(data.data);
                }

                emit(parsedData);
              };

              var connectionInstance = connection.getInstance();
              connectionInstance.onmessage = handler;

              connectionInstance.onerror = function (event) {
                history.push(Routes.Error);
                handler(JSON.stringify({
                  eventType: SocketEvent.SocketDown
                }));
              };

              connectionInstance.onclose = function (event) {
                if (event.code !== 1000) {
                  history.push(Routes.Error);
                }

                handler(JSON.stringify({
                  eventType: SocketEvent.SocketDown
                }));
              };

              return function () {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                connectionInstance.onmessage = undefined;
              };
            });
          };

          _context.next = 17;
          return call(getEventChannel, connection);

        case 17:
          channel = _context.sent;

        case 18:
          if (!true) {
            _context.next = 36;
            break;
          }

          _context.next = 21;
          return take(channel);

        case 21:
          event = _context.sent;

          if (typeof event === 'string') {
            event = JSON.parse(event);
          }

          if (!(event.eventType === SocketEvent.SocketDown)) {
            _context.next = 32;
            break;
          }

          if (!connection) {
            _context.next = 28;
            break;
          }

          _context.next = 27;
          return call([connection, connection.stop]);

        case 27:
          connection = null;

        case 28:
          _context.next = 30;
          return put(actions.fetchSocketConnectFailure({
            error: new Error(ConstantsUtil.errors.SOCKET_IS_DOWN)
          }));

        case 30:
          _context.next = 34;
          break;

        case 32:
          _context.next = 34;
          return put(actions.receiveSocketEvent(event));

        case 34:
          _context.next = 18;
          break;

        case 36:
          _context.next = 44;
          break;

        case 38:
          _context.prev = 38;
          _context.t0 = _context["catch"](0);
          _context.next = 42;
          return put(actions.fetchSocketConnectFailure({
            error: _context.t0
          }));

        case 42:
          _context.next = 44;
          return put({
            type: "".concat(FETCH_SOCKET_CONNECT_REQUEST, "/").concat(ConstantsUtil.actions.ASYNC_FAILED)
          });

        case 44:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 38]]);
}

function fetchSocketConnectSagaWatcher() {
  return _regeneratorRuntime.wrap(function fetchSocketConnectSagaWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeEvery(FETCH_SOCKET_CONNECT_REQUEST, fetchSocketConnectSagaWorker);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

function sendSocketEventSagaWorker(action) {
  var _connection;

  return _regeneratorRuntime.wrap(function sendSocketEventSagaWorker$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;

          if (!((_connection = connection) !== null && _connection !== void 0 && _connection.getConnected())) {
            _context3.next = 8;
            break;
          }

          _context3.next = 4;
          return apply(connection, connection.invoke, ['SendEvent', JSON.stringify(action.payload)]);

        case 4:
          _context3.next = 6;
          return put(actions.fetchSendSocketEventSuccess(action.payload));

        case 6:
          _context3.next = 8;
          return put({
            type: "".concat(FETCH_SEND_SOCKET_EVENT_REQUEST, "/").concat(ConstantsUtil.actions.ASYNC_SUCCESS)
          });

        case 8:
          _context3.next = 16;
          break;

        case 10:
          _context3.prev = 10;
          _context3.t0 = _context3["catch"](0);
          _context3.next = 14;
          return put(actions.fetchSendSocketEventError({
            error: _context3.t0
          }));

        case 14:
          _context3.next = 16;
          return put({
            type: "".concat(FETCH_SEND_SOCKET_EVENT_REQUEST, "/").concat(ConstantsUtil.actions.ASYNC_FAILED)
          });

        case 16:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[0, 10]]);
}

function sendSocketEventSagaWatcher() {
  return _regeneratorRuntime.wrap(function sendSocketEventSagaWatcher$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return takeEvery(FETCH_SEND_SOCKET_EVENT_REQUEST, sendSocketEventSagaWorker);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}

function fetchSocketDisconnectSagaWorker(action) {
  return _regeneratorRuntime.wrap(function fetchSocketDisconnectSagaWorker$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;

          if (!connection) {
            _context5.next = 5;
            break;
          }

          _context5.next = 4;
          return call([connection, connection.stop]);

        case 4:
          connection = null;

        case 5:
          _context5.next = 7;
          return put(actions.fetchSocketDisconnectSuccess({}));

        case 7:
          _context5.next = 9;
          return put({
            type: "".concat(FETCH_SOCKET_DISCONNECT_REQUEST, "/").concat(ConstantsUtil.actions.ASYNC_SUCCESS)
          });

        case 9:
          _context5.next = 17;
          break;

        case 11:
          _context5.prev = 11;
          _context5.t0 = _context5["catch"](0);
          _context5.next = 15;
          return put(actions.fetchSocketDisconnectFailure({
            error: _context5.t0
          }));

        case 15:
          _context5.next = 17;
          return put({
            type: "".concat(FETCH_SOCKET_DISCONNECT_REQUEST, "/").concat(ConstantsUtil.actions.ASYNC_FAILED)
          });

        case 17:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[0, 11]]);
}

function fetchSocketDisconnectSagaWatcher() {
  return _regeneratorRuntime.wrap(function fetchSocketDisconnectSagaWatcher$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return takeEvery(FETCH_SOCKET_DISCONNECT_REQUEST, fetchSocketDisconnectSagaWorker);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}

export default function socketSaga() {
  return _regeneratorRuntime.wrap(function socketSaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return all([fork(fetchSocketConnectSagaWatcher), fork(sendSocketEventSagaWatcher), fork(fetchSocketDisconnectSagaWatcher)]);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}